import { FullScreenBox } from '@aibees/shared/components/full-screen-box';
import { useSearchParams } from '@aibees/shared/router';
import { useParams } from 'react-router-dom';
import { ExpiredLinkPasswordPage } from './components/expired-link-password-page';
import { Transfer } from './components/transfer';
import { useValidateTransferLink } from './hooks/use-validate-transfer-link';

export function LinkView() {
  const { id } = useParams();
  const { username, firstname, lastname } = useSearchParams();

  const isValid = useValidateTransferLink({
    id,
    username,
    firstname,
    lastname,
  });

  return (
    <FullScreenBox>
      {isValid === true && <Transfer />}
      {isValid === false && <ExpiredLinkPasswordPage />}
    </FullScreenBox>
  );
}
